import { createReducer, createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	loginRequest: ["email", "tel", "password"],
	loginSuccess: ["payload"],
	loginFailure: null,
});

export const AuthenTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	token: null,
	loading: false,
};

/* ------------- Reducers ------------- */

// request the data from an api
export const loginRequest = state => Object.assign({}, state, { loading: true });
export const loginSuccess = (state, { payload: { token } }) => (
	Object.assign({}, state, { token: token, loading: false })
);
export const loginFailure = state => Object.assign({}, state, { loading: false });


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.LOGIN_REQUEST]: loginRequest,
	[Types.LOGIN_SUCCESS]: loginSuccess,
	[Types.LOGIN_FAILURE]: loginFailure,
});



// WEBPACK FOOTER //
// ./src/reducers/AuthenReducer.js